import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m100 40.603 84.853 84.853-9.9 9.9-84.852-84.853zM32 32h36v36H32z" }, null, -1),
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "6",
      fill: "var(--mc-avatar)"
    }, null, -1),
    _createElementVNode("path", { d: "m148 28 8 24h24l-20 16 8 24-20-16-20 16 8-24-20-16h24z" }, null, -1)
  ]))]))
}
export default { render: render }